import React, { useState } from "react";
import BetterAlerts from "../BetterAlerts";
import BetterBox from "../BetterBox";
import { Button } from "react-bootstrap";
import PinInput from 'react-pin-input';
import '../../style/password.scss';

export default function CodePassword({ errors, submitted, handleSubmit, voltar }) {
	const [codigo, setCodigo] = useState('');

	return (
		<div>
			<div className="col-sm-12">
				<BetterAlerts errors={errors} />
			</div>

			<div>
				<div className="col-sm-12">
					<BetterBox title="Digite seu código." subtitle="Insira o código de 6 dígitos que foi enviado para seu e-mail.">
						<PinInput
							length={6}
							focus
							autoSelect={true}
							type="numeric"
							inputMode="number" 
							onComplete={(value) => setCodigo(value)}
							placeholder={'0'}
						/>
					</BetterBox>
				</div>

				<div className="col-sm-12">
					<div className="d-flex justify-content-between">
						<Button style={{ fontWeight: 400 }} disabled={submitted} variant="secondary" onClick={voltar}>
							Voltar
						</Button>

						<Button
							disabled={submitted || codigo.length < 6}
							className="btn btn-primary btn-lg btn-bold tt-14"
							onClick={() => { handleSubmit(codigo) }}
						>
							<i className={`margin-icon ${submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>
							Enviar
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}